import {
  createSnippet,
  deleteSnippet,
  getSnippet,
  getSnippets,
  updateSnippet,
} from 'lib/api';
import { decodeAndReplaceText } from 'lib/utils/functions';
import {
  CreateParams,
  GetSnippetParams,
  SnippetQuery,
  SnippetItem,
  SNIPPETS_ACTIONS,
} from '.';

const {
  GET_SNIPPETS_START,
  GET_SNIPPETS_ERROR,
  GET_SNIPPETS_SUCCESS,
  GET_SNIPPET_START,
  GET_SNIPPET_ERROR,
  GET_SNIPPET_SUCCESS,
  ADD_SNIPPETS_START,
  ADD_SNIPPETS_ERROR,
  ADD_SNIPPETS_SUCCESS,
  DELETE_SNIPPETS_START,
  DELETE_SNIPPETS_ERROR,
  DELETE_SNIPPETS_SUCCESS,
  EDIT_SNIPPET_START,
  EDIT_SNIPPET_ERROR,
  EDIT_SNIPPET_SUCCESS,
} = SNIPPETS_ACTIONS;

export const loadSnippets = async ({
  size,
  page,
  sort,
  search,
  sharedWith,
  dispatch,
}: SnippetQuery): Promise<void> => {
  dispatch({ type: GET_SNIPPETS_START });

  const response = await getSnippets({
    limit: size,
    start: page,
    sort: sort,
    search: search,
    sharedWith: sharedWith,
  }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_SNIPPETS_ERROR,
      error: response.message,
    });
    return;
  }
  response.snippets.map(async (snippet: SnippetItem) => {
    return decodeText(snippet);
  });
  dispatch({
    type: GET_SNIPPETS_SUCCESS,
    payload: {
      snippets: response.snippets,
      count: response.count,
    },
  });
};

export const loadSnippet = async ({
  snippetId,
  dispatch,
}: GetSnippetParams): Promise<void> => {
  dispatch({ type: GET_SNIPPET_START });

  const response = await getSnippet(snippetId).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_SNIPPET_ERROR,
      error: response.message,
    });
    return;
  }
  const decodedResponse = await decodeText(response);
  dispatch({
    type: GET_SNIPPET_SUCCESS,
    payload: {
      snippet: decodedResponse,
    },
  });
};

export const addSnippet = async ({
  data,
  dispatch,
}: CreateParams): Promise<SnippetItem | undefined> => {
  dispatch({ type: ADD_SNIPPETS_START });
  data = await encodeText(data);
  const snippet: SnippetItem = await createSnippet({ data }).catch(err => err);

  if (snippet instanceof Error) {
    dispatch({
      type: ADD_SNIPPETS_ERROR,
      error: snippet.message,
    });
    return;
  }

  const decodedSnippet = await decodeText(snippet);
  dispatch({
    type: ADD_SNIPPETS_SUCCESS,
    payload: {
      decodedSnippet,
    },
  });

  return snippet;
};

export const editSnippet = async ({ data, dispatch }: any): Promise<void> => {
  dispatch({ type: EDIT_SNIPPET_START });
  data = await encodeText(data);
  const snippet = await updateSnippet(data as SnippetItem).catch(err => err);
  if (snippet instanceof Error) {
    dispatch({
      type: EDIT_SNIPPET_ERROR,
      error: snippet.message,
    });
    return;
  }
  const decodedSnippet = await decodeText(snippet);
  const payload = {
    decodedSnippet,
  };
  dispatch({ type: EDIT_SNIPPET_SUCCESS, payload });
};

export const removeSnippet = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_SNIPPETS_START });

  const snippets = await deleteSnippet({ data }).catch(err => err);
  if (snippets instanceof Error) {
    dispatch({
      type: DELETE_SNIPPETS_ERROR,
      error: snippets.message,
    });
    return;
  }
  const payload = {
    snippets,
    data,
  };
  dispatch({ type: DELETE_SNIPPETS_SUCCESS, payload });
};

const encodeText = (snippet: SnippetItem) => {
  snippet.emailText = encodeURIComponent(snippet.emailText || '');
  snippet.smsText = encodeURIComponent(snippet.smsText || '');
  return snippet;
};

const decodeText = (snippet: SnippetItem) => {
  snippet.emailText = decodeAndReplaceText(snippet.emailText || '', true);
  snippet.smsText = decodeAndReplaceText(snippet?.smsText || '', true);
  return snippet;
};
